import LabelChecklist from "./LabelChecklist";
import DateChecklist from "./DateChecklist";
import InputChecklist from './InputChecklist'
import TextareaChecklist from './TextareaChecklist'
import CardChecklist from './CardChecklist'
import ChoiceChecklist from './ChoiceChecklist'

export function checklistComponents(field){
    if(field.type.toLowerCase() == 'label') {
        return(
          <div className="col-lg-12">
            <LabelChecklist label={field.label}/>
          </div>
        )
    } else if(field.type.toLowerCase()  == 'date') {
        return(
          <div className="col-sm-12 col-md-4 mb-2">
            <DateChecklist label={field.label} required={field.required} value={field.value}/>
          </div>
        )
    } else if(field.type.toLowerCase()  == 'input' || field.type.toLowerCase()  == 'integer') {
        return (
          <div className="col-sm-12 col-md-4 mb-2">
            <InputChecklist label={field.label} required={field.required} type={field.type.toLowerCase() == 'integer' ? 'number' : 'text'} value={field.value}/>
          </div>
        )
    } else if(field.type.toLowerCase()  == 'textarea') {
        return (
          <div className="col-lg-12">
            <TextareaChecklist label={field.label} required={field.required} maxLength={field.maxLength} lines={field.lines} value={field.value}/> 
          </div>
        )
    } else if(field.type.toLowerCase()  == 'card') {
        return (
          <div className="col-lg-12">
            <CardChecklist title={field.title} groups={field.groups} /> 
          </div>
        )
    } else if(field.type.toLowerCase()  == 'choice') {
        return (
            <div className="col-sm-12 col-md-4 mb-2">
                <ChoiceChecklist label={field.label} required={field.required} options={field.values} value={field.value}/> 
            </div>
        )
    }
}
